/* Brush eight kaitori: progressive enhancement; no network calls, no PII analytics. */
(() => {
  'use strict';
  const init = (root) => {
    if (!root || root.dataset.beInitialized === 'true') return;
    root.dataset.beInitialized = 'true';
    const emit = (action, channel = '', placement = '') => {
      root.dispatchEvent(new CustomEvent('be:kaitori', {bubbles:true, detail:{action,channel,placement}}));
    };
    root.querySelectorAll('[data-be-channel]').forEach(link => link.addEventListener('click', () => {
      emit('cta_click', link.dataset.beChannel, link.dataset.bePlacement || '');
    }));
    const sticky = root.querySelector('[data-be-sticky]');
    const hero = root.querySelector('[data-be-hero]');
    const contact = root.querySelector('[data-be-contact]');
    if (sticky && hero && contact && 'IntersectionObserver' in window) {
      let heroVisible = true, contactVisible = false;
      const update = () => {
        const active = document.activeElement;
        const editing = active && root.contains(active) && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
        const blocked = root.dataset.beStickyBlocked === 'true';
        sticky.hidden = heroVisible || contactVisible || editing || blocked;
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.target === hero) heroVisible = entry.isIntersecting;
          if(entry.target === contact) contactVisible = entry.isIntersecting;
        });update();
      });
      observer.observe(hero);observer.observe(contact);
      root.addEventListener('focusin',update);root.addEventListener('focusout',()=>setTimeout(update,0));
      root.addEventListener('be:kaitori:overlay',event=>{
        root.dataset.beStickyBlocked = event.detail && event.detail.visible ? 'true':'false';update();
      });
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target.contains(root)) observer.disconnect();
      },{once:true});
      update();
    }
    if (root.querySelector('[data-be-contact-success]')) emit('form_success','form','contact');
  };
  const initAll = (scope) => scope.querySelectorAll('[data-be-kaitori]').forEach(init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
